import { composeIO } from 'react-compose-io'
import { graficoBarraSemanasIO } from './GraficoBarraSemanas.IO'
import { GraficoBarraSemanasView } from './GraficoBarraSemanas.View'

export const GraficoBarraSemanas = composeIO(GraficoBarraSemanasView, graficoBarraSemanasIO)
